import { render, staticRenderFns } from "./header-registration.vue?vue&type=template&id=91e1fa72"
import script from "./header-registration.vue?vue&type=script&lang=js"
export * from "./header-registration.vue?vue&type=script&lang=js"
import style0 from "./header-registration.vue?vue&type=style&index=0&id=91e1fa72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports